import React from 'react';
import NavigationBar from '../components/NavigationBar';
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow } from 'mdb-react-ui-kit';
import LandingFooter from '../components/LandingFooter';
import { checkediconblack } from '../assets/images/images';
import RelatedProducts from '../components/RelatedProducts';
import ContactUs from '../components/ContactUs';
import { useNavigate } from 'react-router';

const ProductsLanding = ({ heading, subtitle, trialText, demoText, imageSrc, infoItems, FeaturesDetails, FeatureHead, FeatureDesc, HighlighCardDetails, AdvantageHeadText, AdvantageDescText, featuresData }) => {
    const navigate = useNavigate();
    const highlight = HighlighCardDetails[0];
    const handleDemoClick = () => {
        navigate('/bookademo');
    };
    const handlePricingClick = () => {
        navigate('/commercials');
    };
    return (
        <>

            <div className="lp">
                <div className="home-section pt-0">
                    <NavigationBar classText="white-color" from={'industry'} />
                    <MDBContainer className='pt-5'>
                        <MDBRow className="align-items-center">
                            <MDBCol size="md-6">
                                <div className="gym-promo">
                                    <h1 className="main-heading">{heading}</h1>
                                    <p className="main-subtitle">{subtitle}</p>

                                    <span
                                        className="btn btn-cta trial-button"
                                        data-bs-toggle="modal"
                                        data-bs-target="#startTrialModal"
                                        onClick={handlePricingClick}
                                    >
                                        {trialText}
                                    </span>
                                    &nbsp;&nbsp;&nbsp;
                                    <a className="btn btn-cta btn-cta-outline-v2 demo-button" onClick={handleDemoClick}>
                                        {demoText}
                                    </a>

                                    <p className="info-text deskContent">
                                        {infoItems?.map((item, i) => (
                                            <span className="pe-3" key={i}>
                                                <i className="bi bi-patch-check-fill"></i>&nbsp;{item}
                                            </span>
                                        ))}
                                    </p>
                                </div>
                            </MDBCol>

                            <MDBCol size="md-6">
                                <img
                                    src={imageSrc}
                                    className="fitness-software-image"
                                    alt="Hero Visual"
                                />
                            </MDBCol>
                        </MDBRow>
                    </MDBContainer>
                </div>
            </div>


            <div className='section-white'>
                <MDBContainer className="lp_revenue p-0">
                    <MDBCol size='12' className='text-center my-5'>
                        <div div className='mb-3 h2'>{FeatureHead}</div>
                        <p className='text-center'>
                            {FeatureDesc}
                        </p>
                    </MDBCol>
                    {FeaturesDetails.map((feature) => (
                        <React.Fragment key={feature.id}>
                            <MDBRow className={feature.id % 2 == 0 ? 'flex-row-reverse' : ''}>
                                <MDBCol sm='12' md='6' className='my-5 d-flex flex-column justify-content-center'>
                                    <h3 className='lp_title_name'>
                                        {feature.title}
                                    </h3>

                                    <span className='under-line'></span>

                                    <div className='my-4'>
                                        <MDBListGroup>
                                            {feature.description.map((text, index) => (
                                                <MDBListGroupItem noBorders className='lp_custom-list' key={index}>
                                                    <i class="fas fa-check-circle check-icon"></i>
                                                    {text}
                                                </MDBListGroupItem>
                                            ))}
                                            <MDBListGroupItem noBorders className='lp_custom-list link-color'>
                                                {feature.link}
                                            </MDBListGroupItem>
                                        </MDBListGroup>
                                    </div>

                                </MDBCol>
                                <MDBCol sm='12' md='6' className='my-5 text-center ip_slideimg'>
                                    <img src={feature.image} alt={feature.title} />
                                </MDBCol>
                            </MDBRow>
                        </React.Fragment>
                    ))}
                </MDBContainer>
            </div>





            <MDBContainer className="lp_revenue section-white">
                <MDBRow>
                    <MDBCol size='12' className='text-center mb-5 '>
                        <div className='mb-3 h2'> {AdvantageHeadText}</div>
                        <p className='text-center'>
                            {AdvantageDescText}
                        </p>
                    </MDBCol>
                    {featuresData.map((feature, index) => (
                        <MDBCol sm={12} md={6} lg={6} className='mb-3' key={index} style={{ marginTop: '20px' }}>
                            <div className='lp_card'>
                                <MDBCard className='shadow-0'>
                                    <MDBCardBody className='lp_header'>
                                        <img src={feature.icon} alt="" />
                                        <MDBCardTitle className='my-3'>{feature.title}</MDBCardTitle>
                                        <div className='lp_small'>
                                            <ul>
                                                {feature.description.map((text, index) => (
                                                    <li>
                                                        {text}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </MDBCardBody>
                                </MDBCard>
                            </div>
                        </MDBCol>
                    ))}
                </MDBRow>
            </MDBContainer>


            <div className="section-grey">
                <ContactUs />
            </div>
            <LandingFooter />

        </>
    );
};

export default ProductsLanding;
